import type { FlowDefinition, FlowNodeBinding } from '../types';
import { rebuildFlowConnections } from './flows';

const EVENT_SOCKET_IDS = new Set([
  'click',
  'select',
  'trigger',
  'selectionTrigger',
  'finishSelected',
  'coloursChanged',
  'combinationSelected',
]);
const TRIGGER_NODE_TYPES = new Set([
  'add-to-list',
  'remove-from-list',
  'clear-list',
  'trigger-collector',
  'show-message',
  'set-step-tracker',
  'scroll-to-section',
]);

function normalizeInputBindings(nodeBlockType: string, inputs: FlowNodeBinding[]) {
  if (!TRIGGER_NODE_TYPES.has(nodeBlockType)) return inputs;

  const nextBindings: FlowNodeBinding[] = [];
  const seen = new Set<string>();

  inputs.forEach((binding) => {
    const socketId = binding.socketId === 'selectionTrigger' ? 'trigger' : binding.socketId;
    const dedupeKey = `${socketId}:${binding.fieldId}`;
    if (seen.has(dedupeKey)) return;
    seen.add(dedupeKey);
    nextBindings.push({
      ...binding,
      socketId,
    });
  });

  return nextBindings;
}

export function normalizeFlowTriggerBindings(flows: FlowDefinition[]) {
  return flows.map((flow) => {
    const triggerFieldIds = new Set<string>();

    const nextNodes = flow.nodes.map((node) => {
      node.outputs.forEach((binding) => {
        if (EVENT_SOCKET_IDS.has(binding.socketId)) {
          triggerFieldIds.add(binding.fieldId);
        }
      });
      node.inputs.forEach((binding) => {
        if (EVENT_SOCKET_IDS.has(binding.socketId)) {
          triggerFieldIds.add(binding.fieldId);
        }
      });

      return {
        ...node,
        inputs: normalizeInputBindings(node.blockType, node.inputs),
      };
    });

    const nextFields = flow.fields.map((field) =>
      triggerFieldIds.has(field.id) &&
      (field.type === 'event.click' ||
        field.type === 'event.product-select' ||
        field.type === 'event.trigger')
        ? {
            ...field,
            type: 'event.trigger' as const,
          }
        : field
    );

    const nextFlowBase: FlowDefinition = {
      ...flow,
      fields: nextFields,
      nodes: nextNodes,
    };

    return {
      ...nextFlowBase,
      connections: rebuildFlowConnections(nextFlowBase),
    };
  });
}
